const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/calendar.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/calendar')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface BookingEvent {
  id: string;
  petName: string;
  ownerName: string;
  serviceName: string | null;
  serviceType: string | null;
  scheduledDate: string;
  scheduledTime: string;
  duration: number | null;
  status: string;
  priority: string;
  isEmergency: boolean;
  assignedToMemberId: string | null;
  invoiceId?: string | null;
}
interface VaccineDueEvent {
  id: string;
  petName: string;
  ownerName: string | null;
  certificateType: string;
  title: string;
  validUntil: string; // ISO date
}
interface Member {
  id: string;
  displayName: string | null;
  inviteEmail: string;
  roleName?: string;
  user?: {
    fullName: string;
    email: string;
  } | null;
}

// Time slots from 8 AM to 8 PM